<app-user-login *ngIf="!canShowRegistration()" (registerRequested)="registerRequested()" fxFlex></app-user-login>
<app-user-registration *ngIf="canShowRegistration()" (loginRequested)="loginRequested()" fxFlex></app-user-registration>
